"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsValidator = void 0;
const models_1 = require("../models");
const result_1 = require("../result");
class FieldsValidator {
    constructor() {
        this.validableFields = {};
    }
    validateRules(validatorModel) {
        const inputsErrors = {};
        let isSuccess = true;
        Object.entries(this.validableFields).forEach(([fieldName, fieldValidator]) => {
            const result = fieldValidator.validate(validatorModel[fieldName], validatorModel);
            if (!result.isSuccess) {
                isSuccess = false;
                inputsErrors[fieldName] = result.error;
            }
        });
        const validationsErrors = new models_1.ValidationsErrors(inputsErrors);
        return { isSuccess, validationsErrors };
    }
    validate(values, data = {}) {
        const validatorModel = Object.assign(Object.assign({}, data), values);
        const { isSuccess, validationsErrors } = this.validateRules(validatorModel);
        return isSuccess ? result_1.SuccessResult.create(true) : result_1.ErrorResult.create(validationsErrors);
    }
}
exports.FieldsValidator = FieldsValidator;
//# sourceMappingURL=FieldsValidator.js.map